import { DropdownChipItem } from '@/modules/accredited-establishments/components/Filters/DropdownChip'

/**
 * Opens the Especialidade → Subespecialidade chain. Gênero and Atendimento are
 * independent of it and gated only by the specialist category.
 */
const SPECIALIST_CHAIN_ENABLED = true

/**
 * Transcribed from `AccreditedGenderFilter` (atlas-domain-client). Three
 * buckets, not the four members of the backend `Gender` enum: `OTHERS` is
 * defined by excluding MALE and FEMALE, so the buckets partition the providers
 * and their counts sum to the unfiltered total.
 */
const GENDER_OPTIONS: DropdownChipItem[] = [
  { label: 'Feminino', value: 'FEMALE' },
  { label: 'Masculino', value: 'MALE' },
  { label: 'Outros', value: 'OTHERS' }
]

/** Transcribed from `ConsolidatedAccreditedNetworkAppointmentType`. */
const ATTENDANCE_OPTIONS: DropdownChipItem[] = [
  { label: 'Presencial', value: 'PRESENTIAL' },
  { label: 'Online', value: 'REMOTE' }
]

export { SPECIALIST_CHAIN_ENABLED, GENDER_OPTIONS, ATTENDANCE_OPTIONS }
